import { StyleSheet } from 'aphrodite'

import headers from './headers'
import table from './table'
import approval from './approval'
import form from './form'

export default {
  headers: StyleSheet.create(headers),
  table: StyleSheet.create(table),
  approval: StyleSheet.create(approval),
  form: StyleSheet.create(form)
}



// WEBPACK FOOTER //
// ./src/components/Community/Application/Main/style/ColorBlind/index.js